import * as api from "app/api/workstations"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import * as actions from "./workstationAvailabilities.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* getWorkstationAvailabilities(action: actions.GetWorkstationAvailabilitiesAction): SagaIterator {
  try {
    const { payload } = action
    const response = yield call(api.getWorkstationAvailabilities, payload)
    yield put(actions.getWorkstationAvailabilitiesSuccess(response.data))
  } catch (e) {
    yield put(actions.getWorkstationAvailabilitiesFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* workstationsSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getWorkstationAvailabilities)
}
